<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                <img src="/static/img/brand/logo.png" alt="logo">
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="https://demos.creative-tim.com/vue-argon-design-system/documentation/">
                        <img src="/static/img/brand/logo.png">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                <li class="nav-item">
                <a slot="title" href="#" v-scroll-to="'#home'" class="nav-link">
                    <i class="ni ni-shop d-lg-none"></i>
                    <span class="nav-link-inner--text">Home</span>
                </a>
                </li>
                <li class="nav-item">
                <a slot="title" href="#" v-scroll-to="'#analysis'" class="nav-link">
                    <i class="ni ni-chart-bar-32 d-lg-none"></i>
                    <span class="nav-link-inner--text">Analysis</span>
                </a>
                </li>
                <li class="nav-item">
                <a slot="title" href="#" v-scroll-to="'#services'" class="nav-link">
                    <i class="ni ni-spaceship d-lg-none"></i>
                    <span class="nav-link-inner--text">Services</span>
                </a>
                </li>
                <li class="nav-item">
                <a slot="title" href="#" v-scroll-to="'#platforms'" class="nav-link">
                    <i class="ni ni-app d-lg-none"></i>
                    <span class="nav-link-inner--text">Platforms</span>
                </a>
                </li>
                <!--
                <li class="nav-item">
                <a slot="title" href="#" v-scroll-to="'#teams'" class="nav-link">
                    <i class="ni ni-single-02 d-lg-none"></i>
                    <span class="nav-link-inner--text">Team</span>
                </a>
                -->
                </li>
                <li class="nav-item">
                <a slot="title" href="#" v-scroll-to="'#facts'" class="nav-link">
                    <i class="ni ni-bullet-list-67 d-lg-none"></i>
                    <span class="nav-link-inner--text">Facts</span>
                </a>
                </li>
                <li class="nav-item d-lg-block ml-lg-4">
                    <a href="#" v-scroll-to="'#contact'" rel="noopener"
                       class="btn btn-default btn-icon">
                <span class="btn-inner--icon">
                  <i class="fa fa-paper-plane mr-2"></i>
                </span>
                        <span class="nav-link-inner--text">Contact</span>
                    </a>
                </li>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>
<style>
@media (min-width: 992px){
.navbar-main{
  padding: 0 !important;
}
}
.navbar-main{
  position:fixed !important;
  background: #fff !important;
}

.navbar-brand img {
  height: 65px !important;
}

.nav-item .btn{
  border-radius:0 !important;
}

.navbar-transparent .navbar-nav .nav-link{
  color:#000 !important;
}

.navbar-transparent .navbar-nav .nav-link:hover, .navbar-transparent .navbar-nav .nav-link:focus{
  color:#5e72e4 !important;
}

.navbar-toggler{
  background-color: rgba(138,152,235,0.5) !important;
}

@media (max-width: 991.98px)
.navbar-collapse .collapse-brand img {
    height: 60px !important;
}
</style>



// WEBPACK FOOTER //
// src/layout/AppHeader.vue